import { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { useResources } from "./hooks/useResources";
import { ToastProvider } from "./contexts/ToastContext";
import ToastContainer from "./components/toast/ToastContainer";
import "./App.css";

function App() {
  const { getResourceValue } = useResources();

  useEffect(() => {
    // Set dynamic document title
    document.title = getResourceValue("app_title","QMS Web");
  }, [getResourceValue]);

  return (
    <ToastProvider>
      <Router>
        <AppRoutes />
        <ToastContainer />
      </Router>
    </ToastProvider>
  );
}

export default App;
